module.exports = __webpack_public_path__ + "static/inconfidence-fr-logo-255cf88efc8ed6908c04637706757727.png";